import React, { useState } from "react"
import logo from "../../assets/img/BlackLogo.svg"
import WelcomeSection from "./WelcomeSection"
import OptionsSection from "./OptionsSection"
import { AnimatePresence } from "framer-motion"
import { useProfile } from "../../contexts/ProfileContextProvider"

export const BoardingModal = () => {
    const { hasOnboarded } = useProfile()
    const [toggleOptions, setToggleOptions] = useState(
        hasOnboarded ? false : true,
    )

    return (
        <div className="absolute top-0 bottom-0 left-0 right-0 flex flex-col z-50 bg-color-1 px-4 ">
            <div className="w-full flex justify-center items-center py-4">
                <img src={logo} className="h-8 flex-1" alt="hotspot-logo" />
            </div>
            <AnimatePresence mode="wait">
                {!toggleOptions && (
                    <WelcomeSection
                        key="0"
                        handleToggleOptions={() => setToggleOptions(true)}
                    />
                )}
                {toggleOptions && <OptionsSection key="1" />}
            </AnimatePresence>
        </div>
    )
}
